//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../Fields/Fields.Field.js";
let d=[[[0,"CombineTable",1,0],[0,"FieldExpressionUnits",0,"Unit",0]],[[["field_exp_string","unit_type","indep_var_array","update_flag"],"EditFieldExpression",{},4,0],[[],"GetFieldExpressionString",{R_:{field_exp_string:''}},0,0],[["field_exp_string","updateFlag"],"SetFieldExpressionString",{},2,0]],[]];
SPLM.Fields.FieldExpression = class extends SPLM.Fields.Field{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.FieldExpression";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.FieldExpression.CombineTableOption = Object.freeze({
    "Intersection" : "Intersection", "Union" : "Union"});

export default SPLM;